module.exports = __webpack_public_path__ + "img/woman.ad0a7c38.svg";